module.exports = __webpack_public_path__ + "img/canbadge_daishi_90_110mm_trimmark.c8a36b1a.png";